<div class="py-4 container-fluid overload-review-page">
  <h4 class="mb-4 overload-review-title">ตรวจสอบและรับรองบันทึกขออนุมัติตารางสอน</h4>

  <div class="overload-review-card">
    <div class="overload-review-card-body">
      <div class="overload-review-toolbar" [formGroup]="filterForm">
        <div class="overload-review-filter">
          <app-select
            label="ปีการศึกษา"
            formControlName="academicYear"
            [options]="academicYearOptions"
            [clearable]="false"
            [searchable]="false"
            inputClass="ng-select-size-md"
            classes="mb-0"
          ></app-select>
        </div>

        <div class="overload-review-search">
          <app-filter-search-input
            label="เลขที่เอกสาร"
            formControlName="keywords"
            ariaLabel="ค้นหาเลขที่เอกสาร"
            classes="mb-0"
            (searchSubmit)="onSearch()"
          ></app-filter-search-input>
        </div>
      </div>

      <div class="segmented-tabs segmented-tabs--sm overload-review-tabs" role="tablist" aria-label="สถานะบันทึกขออนุมัติตารางสอน">
<button [attr.aria-selected]="activeTab() === 'all'" role="tab"
          type="button"
          class="segmented-tab overload-review-tab"
          [class.active]="activeTab() === 'all'"
          (click)="onTabChange('all')"
        >
          ทั้งหมด
        </button>
<button [attr.aria-selected]="activeTab() === 'pending'" role="tab"
          type="button"
          class="segmented-tab overload-review-tab"
          [class.active]="activeTab() === 'pending'"
          (click)="onTabChange('pending')"
        >
          รอดำเนินการ
        </button>
<button [attr.aria-selected]="activeTab() === 'revision'" role="tab"
          type="button"
          class="segmented-tab overload-review-tab"
          [class.active]="activeTab() === 'revision'"
          (click)="onTabChange('revision')"
        >
          ส่งกลับแก้ไข
        </button>
<button [attr.aria-selected]="activeTab() === 'certified'" role="tab"
          type="button"
          class="segmented-tab overload-review-tab"
          [class.active]="activeTab() === 'certified'"
          (click)="onTabChange('certified')"
        >
          รับรองแล้ว
        </button>
      </div>

      <ng-template #statusTemplate let-row="row">
        <app-status-badge
          [tone]="statusDisplay(row.statusCode).tone"
          [label]="statusDisplay(row.statusCode).label"
        />
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <button
          type="button"
          class="btn overload-review-action-button datatable-view-action-button"
          aria-label="ดูบันทึกขออนุมัติตารางสอน"
          (click)="onView(row)"
        >
          <img
            src="assets/media/icons/svg/eye.svg"
            class="overload-review-action-icon datatable-view-action-icon"
            alt=""
            aria-hidden="true"
          />
        </button>
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="10"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="overload memo review pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>

@if (detailOpen()) {
  <div class="overload-review-modal-overlay" role="presentation">
    <div
      class="overload-review-modal-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="overloadReviewDetailTitle"
    >
      @if (selectedRow(); as row) {
        <div class="overload-review-detail-header">
          <div class="overload-review-detail-heading">
            <h5 id="overloadReviewDetailTitle">บันทึกขออนุมัติตารางสอน {{ row.documentNumber }}</h5>
            <app-status-badge
              [tone]="statusDisplay(row.statusCode).tone"
              [label]="statusDisplay(row.statusCode).label"
              size="md"
            />
          </div>
          <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseDetail()"></button>
        </div>

        <div class="overload-review-detail-body">
          <div class="overload-review-detail-meta">
            <span>เทอม: {{ row.academicTerm }}/{{ row.year }}</span>
            <span>วันที่: {{ row.effectiveDate }}</span>
            <span>จำนวนอาจารย์: {{ row.entriesCount }}</span>
          </div>

          @if (pdfPreviewUrl(); as previewUrl) {
            <iframe
              class="overload-review-pdf-frame"
              [src]="previewUrl"
              title="Overload memo PDF preview"
            ></iframe>
          } @else if (pdfLoading()) {
            <div class="overload-review-empty">กำลังโหลด PDF...</div>
          } @else if (pdfError()) {
            <div class="overload-review-empty">ไม่สามารถโหลด PDF ได้</div>
          } @else {
            <div class="overload-review-empty">ยังไม่มี PDF</div>
          }
        </div>

        <div class="overload-review-detail-footer">
          @if (canDownloadPdf(row)) {
            <button
              type="button"
              class="btn btn-primary"
              (click)="onDownloadPdf()"
            >
              ดาวน์โหลด PDF
            </button>
          }
          @if (canReviewMemo()) {
            <button
              type="button"
              class="btn btn-outline-danger"
              [disabled]="!canReject(row) || actionLoading()"
              (click)="onOpenReject()"
            >
              ส่งกลับแก้ไข
            </button>
            <button
              type="button"
              class="btn btn-primary"
              [disabled]="!canCertify(row) || actionLoading()"
              (click)="onOpenCertifyConfirm()"
            >
              รับรอง
            </button>
          }
        </div>
      }
    </div>
  </div>
}

@if (rejectOpen()) {
  <div class="overload-review-modal-overlay overload-review-modal-overlay-stacked" role="presentation">
    <div
      class="overload-review-reject-panel"
      role="dialog"
      aria-modal="true"
      aria-labelledby="overloadReviewRejectTitle"
    >
      <div class="overload-review-detail-header">
        <h5 id="overloadReviewRejectTitle">ส่งกลับแก้ไขบันทึกขออนุมัติตารางสอน</h5>
        <button type="button" class="btn-close" aria-label="ปิด" (click)="onCloseReject()"></button>
      </div>
      <form [formGroup]="rejectForm" class="overload-review-reject-body" (ngSubmit)="onSubmitReject()">
        <app-textarea
          label="เหตุผล"
          formControlName="comment"
          [rows]="5"
          [required]="true"
          [error]="rejectForm.controls.comment.invalid && rejectForm.controls.comment.touched ? rejectForm.controls.comment.errors : null"
        ></app-textarea>
        <div class="overload-review-detail-footer">
          <button type="button" class="btn btn-light" [disabled]="actionLoading()" (click)="onCloseReject()">ยกเลิก</button>
          <button type="submit" class="btn btn-danger" [disabled]="actionLoading()">
            {{ actionLoading() ? 'กำลังดำเนินการ...' : 'ยืนยันส่งกลับแก้ไข' }}
          </button>
        </div>
      </form>
    </div>
  </div>
}

<app-confirm-dialog
  #certifyConfirmDialog
  modalId="overloadMemoCertifyConfirmDialog"
  icon="success"
  title="ยืนยันการรับรองบันทึกขออนุมัติตารางสอน"
  message="ต้องการรับรองบันทึกขออนุมัติตารางสอนนี้หรือไม่ ?"
  cancelText="ยกเลิก"
  confirmText="รับรอง"
  [isProcessing]="actionLoading()"
  [stackAboveModal]="true"
  (confirmed)="onConfirmCertify()"
></app-confirm-dialog>

<app-confirm-dialog
  #actionSuccessDialog
  modalId="overloadMemoReviewSuccessDialog"
  icon="success"
  [title]="successTitle()"
  [message]="successMessage()"
  confirmText="ปิด"
  [showCancelButton]="false"
  [stackAboveModal]="true"
  (confirmed)="actionSuccessDialog.close()"
></app-confirm-dialog>
